import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableRow } from '@mui/material';

export const STUDIO_SHORTCUTS: Array<[string, string]> = [
  ['Space', 'Play or pause'],
  ['← / →', 'A frame back or forward'],
  ['Shift + ← / →', 'Five seconds back or forward'],
  ['Home / End', 'The start or the end'],
  ['I / O', 'Mark the start / the end of a stretch'],
  ['Delete', 'Remove the marked stretch, or the selected item'],
  ['S', 'Split the stretch at the playhead'],
  ['L', 'Loop the marked stretch'],
  ['M', 'Mute or unmute the preview'],
  ['F', 'Fullscreen'],
  ['Esc', 'Clear the mark and the selection'],
  ['⌘Z / ⇧⌘Z', 'Undo / redo'],
  ['?', 'This list'],
];

const ShortcutsDialog: React.FC<{ open: boolean; onClose: () => void }> = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Keyboard shortcuts</DialogTitle>
    <DialogContent dividers>
      <Table size="small" data-testid="shortcuts">
        <TableBody>
          {STUDIO_SHORTCUTS.map(([keys, what]) => (
            <TableRow key={keys}>
              <TableCell sx={{ whiteSpace: 'nowrap', width: 130 }}><Box component="kbd" sx={{ fontFamily: 'inherit', fontWeight: 700 }}>{keys}</Box></TableCell>
              <TableCell>{what}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </DialogContent>
    <DialogActions><Button onClick={onClose}>Close</Button></DialogActions>
  </Dialog>
);

export default ShortcutsDialog;
